import { getVisibilityColumns } from '@components/ColumnsVisibilityToggle/getVisibilityColumns';

import { columns } from './columns';

const salesAndPurchasesVisibilityColumns = getVisibilityColumns(columns);

export { salesAndPurchasesVisibilityColumns };
